const Home = () => import("../../views/home/home.vue");
const router = {
    path: '/home',
    name: 'Home',
    component: Home,
}

export default router;


// WEBPACK FOOTER //
// ./src/router/modules/home.js